/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const PAYROLL_POLICY_STEP = {
    DETAILS: 0,
    RULES: 1,
    SUMMARY: 2,
};
